<a [routerLink]="Route.SignIn | routerLink">
  <div class="inline-flex items-center gap-2">
    <span class="font-bold">Zaloguj</span>
  </div>
</a>
